import { forwardRef } from 'react';
import MuiBox, { type BoxProps as MuiBoxProps } from '@mui/material/Box';

export interface BoxProps extends MuiBoxProps {}

const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
  <MuiBox ref={ref} {...props} />
));

export default Box;
